import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { jsPDF } from 'jspdf';
// import autoTable from 'jspdf-autotable';
import axios from 'axios';
import './Chatbot.css';
// import govtLogo from './Govt_logo.png';
import ReportMenu from './ReportMenu';
import { generateExcelReport, generateReportExcel } from './ExportTableData';
import {
  handleColdwaveDailyReportPDF,
  isColdwaveDailyReport,
  isColdwaveDailyReportStatus
} from './reportHandlers/coldwaveHandler';

import {
  handleHeatwaveDailyReportPDF,
  isHeatwaveReport
} from './reportHandlers/heatwaveHandler';

import {
  handleIncidentFacilitiesDownload,
  isIncidentFacilitiesReport
} from './reportHandlers/incidentFacilitiesHandler';

import { generateReportExcel as generateHeatwaveExcel } from './exportTableDataHeatwave';

import {
  handleFireDailyReportPDF,
  handleFireCommunityKitchenPDF,
  isFireDailyReport,
  isFireCommunityKitchenReport,
  isFireDailyReportStatus,
  isFireMISReport
} from './reportHandlers/firewaveHandler';

// import { generateReportExcel as generateFireExcel } from './exportTableDataFire';

import {
  handleHumanLossPrimaryReportPDF,
  handleHumanLossDetailedReportPDF,
  isHumanLossPrimaryReport,
  isHumanLossDetailedReport
} from './reportHandlers/humanLossHandler';

import {
  generateHumanLossPrimaryExcel,
  generateHumanLossDetailedExcel,
  generateHumanLossMISExcel
} from './exportTableDataHumanLoss';
import {
  isFloodForm1DailyReport,
  // isFloodForm1ReportStatus,
  isFloodDailyConsolidatedReport,
  isFloodDailyPartiallyAffectedReport,
  isFloodStateAffectedReport,
  isFloodStatePartiallyAffectedReport,
  isFloodStateConsolidatedReport,
  isFloodMISDistrict,
  isFloodMISDistrictDatewise,
  isFloodMISState,
  isFloodMISStateDatewise
} from './reportHandlers/floodHandler';
// Import Form 1 separately
import { handleFloodForm1DailyReportPDF } from './reportHandlers/floodDailyForm1Handler';
// Add these 5 new imports:
import { handleFloodDailyConsolidatedReportPDF } from "./reportHandlers/floodDailyConsolidatedHandler";
import { handleFloodDailyPartiallyAffectedReportPDF } from "./reportHandlers/floodDailyPartiallyAffectedHandler";
import { handleFloodStateAffectedReportPDF } from "./reportHandlers/floodStateAffectedHandler";
import { handleFloodStatePartiallyAffectedReportPDF } from "./reportHandlers/floodStatePartiallyAffectedHandler";
import { handleFloodStateConsolidatedReportPDF } from "./reportHandlers/floodStateConsolidatedHandler";

import { generateReportExcel as generateFloodExcel } from './exportTableDataFlood';

// const SHOW_DEBUG_INFO = true;
import {
  handlePreDisasterAlertDownload,
  isPreDisasterAlertReport
} from './reportHandlers/preDisasterAlertHandler';
import {
  handleCloudburstDailyReportPDF,
  isCloudburstReport,
  isCloudburstStatus,
  isCloudburstMIS
} from './reportHandlers/cloudburstHandler';
import { generateCloudburstExcel } from './exportTableDataCloudburst';

import {
  handleAvalancheDailyReportPDF,
  isAvalancheReport,
  isAvalancheStatus,
  isAvalancheMIS
} from './reportHandlers/avalancheHandler';
import { generateAvalancheExcel } from './exportTableDataAvalanche';

import { handleEarthquakeDailyReportPDF, isEarthquakeReport, isEarthquakeStatus, isEarthquakeMIS } from './reportHandlers/earthquakeHandler';
import { generateEarthquakeExcel } from './exportTableDataEarthquake';

import { handleGlofReportPDF, isGlofReport, isGlofStatus, isGlofMIS } from './reportHandlers/glofHandler';
import { generateGlofExcel } from './exportTableDataGlof';
import { Bot, RotateCcw } from 'lucide-react';
import InformationMenu from './InformationMenu.js';

const extractDateRange = (rawData, message) => {
  let fromDate, toDate;

  if (rawData?.from_date && rawData?.to_date) {
    fromDate = rawData.from_date;
    toDate = rawData.to_date;
    console.log('✅ Dates from rawData');
  } else if (message?.debug?.tool_result?.parameters) {
    const params = message.debug.tool_result.parameters;
    fromDate = params.from_date || params.fromDate;
    toDate = params.to_date || params.toDate;
    console.log('✅ Dates from tool_result.parameters');
  } else if (message?.debug?.parameters) {
    fromDate = message.debug.parameters.from_date || message.debug.parameters.fromDate;
    toDate = message.debug.parameters.to_date || message.debug.parameters.toDate;
    console.log('✅ Dates from debug.parameters');
  }

  return { fromDate, toDate };
};

export const downloadReport = async (message, format, messageIndex) => {
  try {
    console.log('═════════════════════════════════════════════════════════');
    console.log('🔍 DOWNLOAD REPORT ROUTER - COMPLETE FIX VERSION');
    console.log('═════════════════════════════════════════════════════════');

    // ✅ FIX: Extract data - check MULTIPLE paths for rawData
    let rawData =
      message.debug?.tool_result?.result?.data ||
      message.debug?.toolresult?.result?.data ||
      message.debug?.tool_result?.data ||
      message.debug?.toolresult?.data ||
      message.debug?.data ||
      {};

    // ✅ FIX: Check BOTH snake_case AND camelCase for tool name
    const toolName =
      message.debug?.tool_name ||              // ← Backend sends this
      message.debug?.toolname ||               // ← Fallback
      message.debug?.tool_result?.tool_name ||
      message.debug?.toolresult?.toolname ||
      message.debug?.tool_result?.parameters?.tool_name ||
      message.debug?.toolresult?.parameters?.toolname ||
      message?.tool_name ||
      message?.toolname ||
      null;

    const columnOrder =
      message.debug?.column_order ||
      message.debug?.columnorder;

    const filename = message.debug?.filename;

    // Fallback: Check displaydata structure
    const toolResult =
      message.debug?.tool_result?.result ||
      message.debug?.toolresult?.result;

    if (!rawData && (toolResult?.displaydata || toolResult?.display_data)) {
      console.log('📦 Using displaydata structure from result');
      rawData = toolResult.data;
    }

    // ✅ ENHANCED DEBUG LOGGING
    console.log('📊 Extracted Data:');
    console.log('  - Tool name:', toolName);
    console.log('  - Tool name type:', typeof toolName);
    console.log('  - Tool name lowercase:', toolName?.toLowerCase());
    console.log('  - Format:', format);
    console.log('  - Has rawData:', !!rawData);
    console.log('  - rawData keys:', Object.keys(rawData || {}));
    console.log('  - rawData sample:', rawData);

    // ✅ DEEP DEBUG: Show message structure
    console.log('🔍 Message Structure Debug:');
    console.log('  - message.debug keys:', Object.keys(message.debug || {}));

    // ✅ VALIDATION: Check if toolName was found
    if (!toolName) {
      console.error('═════════════════════════════════════════════════════════');
      console.error('❌ CRITICAL: toolName is undefined!');
      console.error('📋 Available message.debug keys:', Object.keys(message.debug || {}));
      console.error('📋 Full message.debug:', JSON.stringify(message.debug, null, 2));
      console.error('═════════════════════════════════════════════════════════');
      alert('Error: Could not determine report type. Please check console and contact support.');
      return;
    }

    console.log('─────────────────────────────────────────────────────────');

    // ✅ ROUTE 1: COLDWAVE DAILY REPORT (PDF ONLY)
    if (isColdwaveDailyReport(toolName)) {
      console.log('✅ MATCHED ROUTE 1: Coldwave Daily Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Coldwave Daily Report only supports PDF format');
        return;
      }
      await handleColdwaveDailyReportPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 2: COLDWAVE DAILY REPORT STATUS (EXCEL ONLY)
    if (isColdwaveDailyReportStatus(toolName)) {
      console.log('✅ MATCHED ROUTE 2: Coldwave Daily Report Status (Excel)');
      if (format !== 'excel') {
        alert('Coldwave Daily Report Status only supports Excel format');
        return;
      }
      try {
        await generateExcelReport({
          data: rawData,
          columnOrder: columnOrder,
          toolName: 'coldwave_daily_report_status',
          date: message.debug?.tool_result?.parameters?.date ||
                message.debug?.toolresult?.parameters?.date ||
                message.debug?.parameters?.date ||
                new Date().toISOString().split('T')[0],
          filename: filename || 'DailyColdWaveReportStatus'
        });
        console.log('✅ Coldwave Daily Report Status Excel downloaded');
        return;
      } catch (error) {
        console.error('❌ Coldwave Daily Report Status Excel generation failed:', error);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ ROUTE 3: HEATWAVE DAILY REPORT STATUS (EXCEL ONLY)
    if (toolName === 'heatwave_daily_report_status' || toolName === 'heatwavedailyreportstatus') {
      console.log('✅ MATCHED ROUTE 3: Heatwave Daily Report Status (Excel)');
      if (format !== 'excel') {
        alert('Heatwave Daily Report Status only supports Excel format');
        return;
      }
      try {
        const { generateExcelReport } = await import('./exportTableDataHeatwave');
        await generateExcelReport({
          data: rawData,
          columnOrder: columnOrder,
          toolName: 'heatwavedailyreportstatus',
          date: message.debug?.tool_result?.parameters?.date ||
                message.debug?.toolresult?.parameters?.date ||
                message.debug?.parameters?.date ||
                new Date().toISOString().split('T')[0],
          filename: filename || 'DailyHeatWaveReportStatus'
        });
        console.log('✅ Heatwave Daily Report Status Excel downloaded');
        return;
      } catch (error) {
        console.error('❌ Heatwave Daily Report Status Excel generation failed:', error);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ ROUTE 4: HEATWAVE DAILY REPORT (PDF ONLY)
    if (isHeatwaveReport(toolName)) {
      console.log('✅ MATCHED ROUTE 4: Heatwave Daily Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Heatwave Daily Report only supports PDF format');
        return;
      }
      await handleHeatwaveDailyReportPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 5: INCIDENT FACILITIES (EXCEL ONLY)
    if (isIncidentFacilitiesReport(toolName)) {
      console.log('✅ MATCHED ROUTE 5: Incident Facilities (Excel)');
      if (format !== 'excel') {
        alert('Incident Facilities report only supports Excel format');
        return;
      }
      await handleIncidentFacilitiesDownload(message, format);
      return;
    }

    // ✅ ROUTE 6: FIRE DAILY REPORT (PDF ONLY)
    if (isFireDailyReport(toolName)) {
      console.log('✅ MATCHED ROUTE 6: Fire Daily Report (PDF)');
      console.log('  - Tool name:', toolName);
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Fire Daily Report only supports PDF format');
        return;
      }
      console.log('  - Calling handleFireDailyReportPDF()...');
      await handleFireDailyReportPDF(message, format, rawData);
      console.log('  - ✅ PDF generation completed');
      return;
    }

    // ✅ ROUTE 7: FIRE COMMUNITY KITCHEN REPORT (PDF ONLY)
    if (isFireCommunityKitchenReport(toolName)) {
      console.log('✅ MATCHED ROUTE 7: Fire Community Kitchen Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Fire Community Kitchen Report only supports PDF format');
        return;
      }
      await handleFireCommunityKitchenPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 8: FIRE MIS REPORTS (EXCEL ONLY)
    if (isFireMISReport(toolName)) {
      console.log('✅ MATCHED ROUTE 8: Fire MIS Report');
      if (format !== 'excel') {
        alert('Fire MIS Reports only support Excel format');
        return;
      }
      try {
        const { generateReportExcel: generateFireMISExcel } = await import('./exportTableDataFire');

        let selectedView = 'dist_date';
        if (toolName.includes('state_datewise')) selectedView = 'state_date';
        else if (toolName.includes('state') && !toolName.includes('datewise')) selectedView = 'state';
        else if (toolName.includes('district') && !toolName.includes('datewise')) selectedView = 'dist';
        else if (toolName.includes('district_datewise')) selectedView = 'dist_date';

        const { fromDate, toDate } = extractDateRange(rawData, message);

        await generateFireMISExcel({
          data: rawData,
          toolName: toolName,
          displayData: message.debug?.tool_result?.result?.display_data ||
                       message.debug?.toolresult?.result?.displaydata,
          fromDate: fromDate,
          toDate: toDate,
          filename: filename || 'Fire_MIS_Report',
          selectedView: selectedView
        }, selectedView);

        console.log(`✅ Fire MIS Report (${selectedView}) Excel downloaded`);
        return;
      } catch (error) {
        console.error('❌ Fire MIS Report Excel generation failed:', error);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ ROUTE 9: FIRE DAILY REPORT STATUS (EXCEL ONLY)
    if (isFireDailyReportStatus(toolName)) {
      console.log('✅ MATCHED ROUTE 9: Fire Daily Report Status (Excel)');
      if (format !== 'excel') {
        alert('Fire Daily Report Status only supports Excel format');
        return;
      }
      try {
        const { generateFireStatusExcel } = await import('./excelUtilsFire');
        await generateFireStatusExcel({
          data: rawData,
          date: message.debug?.tool_result?.parameters?.date ||
                message.debug?.tool_result?.parameters?.reported_on ||
                message.debug?.parameters?.date ||
                new Date().toISOString().split('T')[0],
          filename: 'DailyFireWaveReportStatus'
        });
        console.log('✅ Fire Daily Report Status Excel downloaded');
        return;
      } catch (error) {
        console.error('❌ Fire Daily Report Status Excel generation failed:', error);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ ROUTE 10: COLDWAVE MIS REPORTS (EXCEL ONLY)
    const coldwaveMisReportTypes = [
      'coldwave_mis_district_datewise',
      'coldwave_mis_district',
      'coldwave_mis_state',
      'coldwave_mis_state_datewise'
    ];

    if (coldwaveMisReportTypes.includes(toolName)) {
      console.log('✅ MATCHED ROUTE 10: Coldwave MIS Report');
      if (format !== 'excel') {
        alert('Coldwave MIS Reports only support Excel format');
        return;
      }

      const displayData = message.debug?.tool_result?.result?.display_data ||
                         message.debug?.toolresult?.result?.displaydata ||
                         message.debug?.tool_result?.result?.displayData ||
                         message.debug?.toolresult?.result?.displayData;
      const { fromDate, toDate } = extractDateRange(rawData, message);

      const viewMap = {
        'coldwave_mis_district_datewise': 'dist_date',
        'coldwave_mis_district': 'dist',
        'coldwave_mis_state': 'state',
        'coldwave_mis_state_datewise': 'state_date'
      };

      const detectedView = viewMap[toolName] || 'dist_date';

      await generateReportExcel({
        data: rawData,
        toolName: toolName,
        displayData: displayData,
        selectedView: detectedView,
        fromDate: fromDate,
        toDate: toDate,
        filename: filename || 'coldwave_mis'
      });
      console.log('✅ Coldwave MIS Report Excel downloaded');
      return;
    }

    // ✅ ROUTE 11: HEATWAVE MIS REPORTS (EXCEL ONLY)
    const heatwaveMisReportTypes = [
      'heatwave_mis_district_datewise',
      'heatwave_mis_district',
      'heatwave_mis_state',
      'heatwave_mis_state_datewise'
    ];

    if (heatwaveMisReportTypes.includes(toolName)) {
      console.log('✅ MATCHED ROUTE 11: Heatwave MIS Report');
      if (format !== 'excel') {
        alert('Heatwave MIS Reports only support Excel format');
        return;
      }

      const displayData = message.debug?.tool_result?.result?.display_data ||
                         message.debug?.toolresult?.result?.displaydata ||
                         message.debug?.tool_result?.result?.displayData ||
                         message.debug?.toolresult?.result?.displayData;
      const { fromDate, toDate } = extractDateRange(rawData, message);

      const viewMap = {
        'heatwave_mis_district_datewise': 'dist_date',
        'heatwave_mis_district': 'dist',
        'heatwave_mis_state': 'state',
        'heatwave_mis_state_datewise': 'state_date'
      };

      const detectedView = viewMap[toolName] || 'dist_date';

      await generateHeatwaveExcel({
        data: rawData,
        toolName: toolName,
        displayData: displayData,
        selectedView: detectedView,
        fromDate: fromDate,
        toDate: toDate,
        filename: filename || 'heatwave_mis'
      }, detectedView);
      console.log('✅ Heatwave MIS Report Excel downloaded');
      return;
    }

    // ✅ ROUTE 12: FIRE MIS REPORTS (EXCEL ONLY) - FALLBACK
    const fireMisReportTypes = [
      'fire_mis_district_datewise',
      'fire_mis_district',
      'fire_mis_state',
      'fire_mis_state_datewise'
    ];

    if (fireMisReportTypes.includes(toolName)) {
      console.log('✅ MATCHED ROUTE 12: Fire MIS Report (Fallback)');
      if (format !== 'excel') {
        alert('Fire MIS Reports only support Excel format');
        return;
      }

      const displayData = message.debug?.tool_result?.result?.display_data ||
                         message.debug?.toolresult?.result?.displaydata ||
                         message.debug?.tool_result?.result?.displayData ||
                         message.debug?.toolresult?.result?.displayData;

      const { fromDate, toDate } = extractDateRange(rawData, message);

      const viewMap = {
        'fire_mis_district_datewise': 'dist_date',
        'fire_mis_district': 'dist',
        'fire_mis_state': 'state',
        'fire_mis_state_datewise': 'state_date'
      };

      const detectedView = viewMap[toolName] || 'dist_date';

      try {
        const { generateReportExcel: generateFireMISExcel } = await import('./exportTableDataFire');

        await generateFireMISExcel({
          data: rawData,
          toolName: toolName,
          displayData: displayData,
          selectedView: detectedView,
          fromDate: fromDate,
          toDate: toDate,
          filename: filename || 'fire_mis'
        }, detectedView);

        console.log('✅ Fire MIS Report Excel downloaded');
        return;
      } catch (error) {
        console.error('❌ Fire MIS Report Excel generation failed:', error);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ ROUTE 13: HUMAN LOSS PRIMARY REPORT (PDF + EXCEL)
    if (isHumanLossPrimaryReport(toolName)) {
      console.log('✅ MATCHED ROUTE 13: Human Loss Primary Report');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));

      if (format === 'pdf') {
        console.log('  → Generating Primary Report PDF...');
        await handleHumanLossPrimaryReportPDF(message, 'pdf', rawData);
        console.log('  ✅ Primary PDF generated');
        return;
      } else if (format === 'excel') {
        console.log('  → Generating Primary Report Excel...');
        await generateHumanLossPrimaryExcel({
          data: rawData,
          filename: 'Human_Loss_Primary_Report'
        });
        console.log('  ✅ Primary Excel generated');
        return;
      }
    }

    // ✅ ROUTE 14: HUMAN LOSS DETAILED REPORT (PDF + EXCEL)
    if (isHumanLossDetailedReport(toolName)) {
      console.log('✅ MATCHED ROUTE 14: Human Loss Detailed Report');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));

      if (format === 'pdf') {
        console.log('  → Generating Detailed Report PDF...');
        await handleHumanLossDetailedReportPDF(message, 'pdf', rawData);
        console.log('  ✅ Detailed PDF generated');
        return;
      } else if (format === 'excel') {
        console.log('  → Generating Detailed Report Excel...');
        await generateHumanLossDetailedExcel({
          data: rawData,
          filename: 'Human_Loss_Detailed_Report'
        });
        console.log('  ✅ Detailed Excel generated');
        return;
      }
    }

    // ✅ ROUTE 15: HUMAN LOSS MIS REPORT (EXCEL ONLY)
    const humanLossMisReportTypes = [
      'human_loss_mis_report',
      'humanlossmisreport',
      'humanloss_mis'
    ];

    if (humanLossMisReportTypes.includes(toolName)) {
      console.log('✅ MATCHED ROUTE 15: Human Loss MIS Report');

      if (format !== 'excel') {
        alert('Human Loss MIS Report only supports Excel format');
        return;
      }

      console.log('  → Generating MIS Report Excel...');
      await generateHumanLossMISExcel({
        data: rawData,
        filename: 'Human_Loss_MIS_Report',
        fromDate: message.debug?.tool_result?.parameters?.from_date ||
                  message.debug?.parameters?.from_date,
        toDate: message.debug?.tool_result?.parameters?.to_date ||
                message.debug?.parameters?.to_date,
        district: message.debug?.tool_result?.parameters?.district ||
                  message.debug?.parameters?.district
      });
      console.log('  ✅ MIS Excel generated');
      return;
    }

    // ✅ ROUTE 16: FLOOD FORM 1 DAILY REPORT (PDF)
    if (isFloodForm1DailyReport(toolName)) {
      console.log('✅ MATCHED ROUTE 16: Flood Form 1 Daily Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Flood Form 1 Daily Report only supports PDF format');
        return;
      }
      await handleFloodForm1DailyReportPDF(message, format, rawData);
      return;
    }

    // ROUTE 17 FLOOD FORM 1 REPORT STATUS EXCEL - PERFECT 6 COLUMNS RED COLORS
    if (toolName === 'floodform1reportstatus' || toolName?.includes('floodform1reportstatus') || toolName?.toLowerCase().includes('form1')) {
      console.log('✅ MATCHED ROUTE 17: Flood Form 1 Report Status Excel');
      console.log('📊 Data received:', rawData?.length || 0, 'rows');
      console.log('🔍 First record sample:', rawData?.[0]);
      console.log('🔍 Has totalmarkedblocks:', rawData?.[0]?.totalmarkedblocks !== undefined);
      console.log('🔍 Backend columnOrder:', columnOrder);

      if (format !== 'excel') {
        alert('Flood Form 1 Report Status only supports Excel format');
        return;
      }

      try {
        // Build columnOrder (existing code stays)
        let fullColumnOrder = [];
        if (Array.isArray(columnOrder) && columnOrder.length > 0) {
          const columnLabels = {
            'dist_name': 'DIST_NAME',
            'total_block_count': 'TOTAL_BLOCK_COUNT',
            'affected': 'Affected Blocks',
            'partially_affected': 'PARTIALLY_AFFECTED',
            'not_affected': 'NOT_AFFECTED',
            'totalmarkedblocks': 'Total Marked Blocks'
          };
          fullColumnOrder = columnOrder.map(key => ({
            key,
            label: columnLabels[key] || key.toString().toUpperCase().replace(/_/g, ' ')
          }));
        }

        if (!columnOrder?.includes('totalmarkedblocks')) {
          fullColumnOrder.push({ key: 'totalmarkedblocks', label: 'Total Marked Blocks' });
        } else {
          // Fallback
          fullColumnOrder = [
            { key: 'dist_name', label: 'District Name' },
            { key: 'total_block_count', label: 'Total Blocks' },
            { key: 'affected', label: 'Affected Blocks' },
            { key: 'partially_affected', label: 'Partially Affected Blocks' },
            { key: 'not_affected', label: 'Not Affected Blocks' },
            { key: 'totalmarkedblocks', label: 'Total Marked Blocks' }
          ];
        }

        const reportDate = message.debug?.tool_result?.parameters?.date ||
                          message.debug?.parameters?.date ||
                          new Date().toISOString().split('T')[0];

        console.log('Form 1 Column Order:', fullColumnOrder.map(col => `${col.key}:${col.label}`));

        // ✅ BULLETPROOF IMPORT + CALL - No TypeScript syntax
        const floodModule = await import('./exportTableDataFlood.js');
        const generateFloodForm1Excel = floodModule.generateFloodForm1Excel;

        console.log('✅ FloodForm1Excel LOADED:', typeof generateFloodForm1Excel === 'function');

        await generateFloodForm1Excel({
          data: rawData,
          columnOrder: fullColumnOrder,
          toolName: 'flood_form1_report_status',
          date: reportDate,
          filename: 'DailyFloodForm1Status'
        });

        console.log('Flood Form 1 Excel downloaded!');
      } catch (error) {
        console.error('Flood Form 1 Excel FAILED:', error);
        console.error('Stack:', error.stack);
        alert('Excel Generation Error: ' + error.message);
      }
      return;
    }

    // ✅ ROUTE 18: FLOOD DAILY CONSOLIDATED REPORT (PDF) ← YOUR TARGET
    if (isFloodDailyConsolidatedReport(toolName)) {
      console.log('✅✅✅ MATCHED ROUTE 18: Flood Daily Consolidated Report (PDF) ← TARGET ✅✅✅');
      console.log('  - Tool name:', toolName);
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      console.log('  - Sample rawData:', JSON.stringify(rawData).substring(0, 500));

      if (format !== 'pdf') {
        alert('Flood Daily Consolidated Report only supports PDF format');
        return;
      }

      console.log('  - Calling handleFloodDailyConsolidatedReportPDF()...');
      await handleFloodDailyConsolidatedReportPDF(message, format, rawData);
      console.log('  - ✅ PDF generation completed');
      return;
    }

    // ✅ ROUTE 19: FLOOD DAILY PARTIALLY AFFECTED REPORT (PDF)
    if (isFloodDailyPartiallyAffectedReport(toolName)) {
      console.log('✅ MATCHED ROUTE 19: Flood Daily Partially Affected Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Flood Daily Partially Affected Report only supports PDF format');
        return;
      }
      await handleFloodDailyPartiallyAffectedReportPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 20: FLOOD STATE AFFECTED REPORT (PDF)
    if (isFloodStateAffectedReport(toolName)) {
      console.log('✅ MATCHED ROUTE 20: Flood State Affected Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Flood State Affected Report only supports PDF format');
        return;
      }
      await handleFloodStateAffectedReportPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 21: FLOOD STATE PARTIALLY AFFECTED REPORT (PDF)
    if (isFloodStatePartiallyAffectedReport(toolName)) {
      console.log('✅ MATCHED ROUTE 21: Flood State Partially Affected Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Flood State Partially Affected Report only supports PDF format');
        return;
      }
      await handleFloodStatePartiallyAffectedReportPDF(message, format, rawData);
      return;
    }

    // ✅ ROUTE 22: FLOOD STATE CONSOLIDATED REPORT (PDF)
    if (isFloodStateConsolidatedReport(toolName)) {
      console.log('✅ MATCHED ROUTE 22: Flood State Consolidated Report (PDF)');
      console.log('  - Passing rawData with keys:', Object.keys(rawData || {}));
      if (format !== 'pdf') {
        alert('Flood State Consolidated Report only supports PDF format');
        return;
      }
      await handleFloodStateConsolidatedReportPDF(message, format, rawData);
      return;
    }

    // ROUTE 23-26: FLOOD MIS REPORTS EXCEL (UNIFIED VERSION)
    if (isFloodMISDistrict(toolName) || isFloodMISDistrictDatewise(toolName) ||
        isFloodMISState(toolName) || isFloodMISStateDatewise(toolName)) {
      console.log('✅ MATCHED ROUTE 23-26: Flood MIS Report Excel');

      if (format !== 'excel') {
        alert('Flood MIS Reports only support Excel format');
        return;
      }

      try {
        // Extract parameters
        const params = message.debug?.tool_result?.parameters || message.debug?.parameters || {};
        const fromDate = params.from_date || params.fromDate;
        const toDate = params.to_date || params.toDate;
        const district = params.district || 'Unknown';
        const block = params.block;

        // Determine report type
        let selectedView = 'distdate';
        if (isFloodMISDistrict(toolName)) selectedView = 'dist';
        else if (isFloodMISDistrictDatewise(toolName)) selectedView = 'distdate';
        else if (isFloodMISState(toolName)) selectedView = 'state';
        else if (isFloodMISStateDatewise(toolName)) selectedView = 'statedate';

        console.log('📊 Flood MIS Report Type:', selectedView);
        console.log('📅 Date Range:', fromDate, 'to', toDate);
        console.log('📍 District:', district, '| Block:', block);

        // ✅ CRITICAL FIX: Extract data based on view type
        let finalData;

        if (selectedView === 'dist' || selectedView === 'state') {
          // ✅ District/State view: Extract from tool_result.result.data
          const toolResultData = message.debug?.tool_result?.result?.data ||
                                  message.debug?.toolResult?.result?.data;

          if (Array.isArray(toolResultData)) {
            finalData = { data: toolResultData };
            console.log('✅ Extracted district/state data from tool_result:', toolResultData.length, 'records');
          } else if (Array.isArray(rawData)) {
            finalData = { data: rawData };
            console.log('✅ Extracted district/state data from rawData array:', rawData.length, 'records');
          } else if (rawData && typeof rawData === 'object' && !Array.isArray(rawData)) {
            // Handle object with numeric keys: {'0': {...}, '1': {...}}
            const dataArray = Object.values(rawData);
            finalData = { data: dataArray };
            console.log('✅ Converted object to array:', dataArray.length, 'records');
          } else {
            console.error('❌ No valid data found for dist/state view');
            alert('No data available for export.');
            return;
          }

        } else if (selectedView === 'distdate' || selectedView === 'statedate') {
          // ✅ Datewise view: Extract from mis_data + cumulative_data
          const dailyData = rawData?.mis_data?.mis_flood_report_district_date ||
                            rawData?.mis_data?.mis_flood_report_state_date || [];
          const cumulativeData = rawData?.cumulative_data?.mis_flood_report_district_date ||
                                 rawData?.cumulative_data?.mis_flood_report_state_date || [];

          console.log('✅ Extracted daily data:', dailyData.length, 'records');
          console.log('✅ Extracted cumulative data:', cumulativeData.length, 'records');

          if (!Array.isArray(dailyData) || dailyData.length === 0) {
            console.error('❌ No daily data found. Available keys:', Object.keys(rawData || {}));
            alert('No data available for export. Please check the report data.');
            return;
          }

          // Build complete rawData structure
          finalData = {
            mis_data: {
              mis_flood_report_district_date: dailyData,
              mis_flood_report_state_date: dailyData
            },
            cumulative_data: {
              mis_flood_report_district_date: cumulativeData,
              mis_flood_report_state_date: cumulativeData
            }
          };
        }

        // Call generateFloodExcel with correct data structure
        await generateFloodExcel({
          data: finalData,
          toolName: toolName,
          fromDate: fromDate,
          toDate: toDate,
          filename: filename || 'FloodMISReport',
          selectedView: selectedView
        });

        console.log('✅ Flood MIS Excel downloaded successfully');
        return;

      } catch (error) {
        console.error('❌ Flood MIS Excel generation failed:', error);
        console.error('Stack:', error.stack);
        alert(`Excel Generation Error: ${error.message}`);
        return;
      }
    }

    // ✅ NEW ROUTE: PRE-DISASTER ALERT REPORT (PDF + EXCEL)
    if (isPreDisasterAlertReport(toolName)) {
      console.log('✅ MATCHED ROUTE: Pre-Disaster Alert Report');
      await handlePreDisasterAlertDownload(message, format);
      return;

    }

    // ---------------- CLOUDBURST ROUTES ----------------
       // 1. Cloudburst Daily PDF
       if (isCloudburstReport(toolName) && !isCloudburstStatus(toolName)) {
           console.log('✅ MATCHED ROUTE: Cloudburst Daily PDF');
           if (format !== 'pdf') return alert('PDF Only');
           await handleCloudburstDailyReportPDF(message, format, rawData);
           return;
       }
   
       // 2. Cloudburst Status Excel
       if (isCloudburstStatus(toolName)) {
           console.log('✅ MATCHED ROUTE: Cloudburst Status Excel');
           if (format !== 'excel') return alert('Excel Only');
           await generateCloudburstExcel({
               data: rawData,
               toolName: 'cloudburst_daily_report_status',
               filename: 'DailyCloudburstStatus'
           });
           return;
       }
   
       // 3. Cloudburst MIS Excel
       if (isCloudburstMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: Cloudburst MIS Excel');
           if (format !== 'excel') return alert('Excel Only');
           let view = 'dist_date';
           if (toolName.includes('state_datewise')) view = 'state_date';
           else if (toolName.includes('district_datewise')) view = 'dist_date';
           else if (toolName.includes('state')) view = 'state';
           else if (toolName.includes('district')) view = 'dist';
   
           await generateCloudburstExcel({ data: rawData, selectedView: view, filename: 'Cloudburst_MIS' });
           return;
       }
   
       // ---------------- AVALANCHE ROUTES ----------------
       // 4. Avalanche Daily PDF
       if (isAvalancheReport(toolName) && !isAvalancheStatus(toolName) && !isAvalancheMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: Avalanche Daily PDF');
           if (format !== 'pdf') return alert('PDF Only');
           await handleAvalancheDailyReportPDF(message, format, rawData);
           return;
       }
   
       // 5. Avalanche Status Excel
       if (isAvalancheStatus(toolName)) {
           console.log('✅ MATCHED ROUTE: Avalanche Status Excel');
           if (format !== 'excel') return alert('Excel Only');
           await generateAvalancheExcel({ data: rawData, toolName: 'avalanche_status', filename: 'AvalancheStatus' });
           return;
       }
   
       // 6. Avalanche MIS Excel
       if (isAvalancheMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: Avalanche MIS Excel');
           if (format !== 'excel') return alert('Excel Only');
           let view = 'dist_date';
           if (toolName.includes('state_datewise')) view = 'state_date';
           else if (toolName.includes('district_datewise')) view = 'dist_date';
           else if (toolName.includes('state')) view = 'state';
           else if (toolName.includes('district')) view = 'dist';
   
           await generateAvalancheExcel({ data: rawData, selectedView: view, filename: 'Avalanche_MIS' });
           return;
       }
   
       // ---------------- GLOF ROUTES ----------------
       // 7. GLOF PDF
       if (isGlofReport(toolName)) {
           console.log('✅ MATCHED ROUTE: GLOF PDF');
           if (format !== 'pdf') return alert('PDF Only');
           await handleGlofReportPDF(message, format, rawData);
           return;
       }
   // 8. GLOF Status Excel
       if (isGlofStatus(toolName)) {
           console.log('✅ MATCHED ROUTE: GLOF Status Excel');
           if (format !== 'excel') return alert('Excel Only');
           await generateGlofExcel({ data: rawData, toolName: toolName, filename: 'GlofStatus' });
           return;
       }
   
       // 9. GLOF MIS Excel
       if (isGlofMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: GLOF MIS Excel');
           if (format !== 'excel') return alert('Excel Only');
           let view = 'dist_date';
           if (toolName.includes('state_datewise')) view = 'state_date';
           else if (toolName.includes('district_datewise')) view = 'dist_date';
           else if (toolName.includes('state')) view = 'state';
           else if (toolName.includes('district')) view = 'dist';
   
           await generateGlofExcel({ data: rawData, selectedView: view, toolName: toolName, filename: 'Glof_MIS' });
           return;
       }
   
       // ---------------- EARTHQUAKE ROUTES ----------------
       // 10. Earthquake Daily PDF
       if (isEarthquakeReport(toolName) && !isEarthquakeStatus(toolName) && !isEarthquakeMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: Earthquake Daily PDF');
           if (format !== 'pdf') return alert('PDF Only');
           await handleEarthquakeDailyReportPDF(message, format, rawData);
           return;
       }
   
       // 11. Earthquake Status Excel
       if (isEarthquakeStatus(toolName)) {
           console.log('✅ MATCHED ROUTE: Earthquake Status Excel');
           if (format !== 'excel') return alert('Excel Only');
           await generateEarthquakeExcel({ data: rawData, toolName: toolName, filename: 'EarthquakeStatus' });
           return;
       }
   
       // 12. Earthquake MIS Excel
       if (isEarthquakeMIS(toolName)) {
           console.log('✅ MATCHED ROUTE: Earthquake MIS Excel');
           if (format !== 'excel') return alert('Excel Only');
           let view = 'dist_date';
           if (toolName.includes('state_datewise')) view = 'state_date';
           else if (toolName.includes('district_datewise')) view = 'dist_date';
           else if (toolName.includes('state')) view = 'state';
           else if (toolName.includes('district')) view = 'dist';
   
           await generateEarthquakeExcel({ data: rawData, selectedView: view, toolName: toolName, filename: 'Earthquake_MIS' });
           return;
       }

    // ❌ UNKNOWN TOOL - Enhanced error logging
    console.log('═════════════════════════════════════════════════════════');
    console.error('❌ NO ROUTE MATCHED - Unknown tool name:', toolName);
    console.error('📋 Debug Information:');
    console.error('  - Tool name:', toolName);
    console.error('  - Tool name (lowercase):', toolName?.toLowerCase());
    console.error('  - Type:', typeof toolName);
    console.error('  - Format requested:', format);
    console.error('  - Has rawData:', !!rawData);
    console.error('  - rawData keys:', Object.keys(rawData || {}));
    console.error('  - Recognition function tests:');
    console.error('    * isFireDailyReport():', isFireDailyReport(toolName));
    console.error('    * isColdwaveDailyReport():', isColdwaveDailyReport(toolName));
    console.error('    * isHeatwaveReport():', isHeatwaveReport(toolName));
    console.error('    * isFloodDailyConsolidatedReport():', isFloodDailyConsolidatedReport(toolName));
    console.log('═════════════════════════════════════════════════════════');

    alert(`Report type not implemented: ${toolName}\n\nPlease check browser console (F12) for details.`);

  } catch (error) {
    console.error('═════════════════════════════════════════════════════════');
    console.error('❌ FATAL ERROR in downloadReport:');
    console.error('Error:', error);
    console.error('Stack:', error.stack);
    console.error('═════════════════════════════════════════════════════════');
    alert(`Error: ${error.message}`);
  }
};

const formatResponseText = (text) => {
  if (!text || typeof text !== 'string') return text;
  let formatted = text
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br>')
    .replace(/→/g, '<span class="arrow">→</span>')
    .replace(/---/g, '<hr class="response-divider">')
    .replace(/\*\*(.+?)\*\*/g, '<div class="section-header">$1</div>')
    .replace(/─{5,}/g, '<hr class="smart-divider">')
  return formatted;
};

/**
 * Parse formatted <pre> block to extract choice names
 * Example input: "<pre>Bachhwara     Bakhri\nBalia         Barauni\n...</pre>"
 * Returns: ["Bachhwara", "Bakhri", "Balia", "Barauni", ...]
 */
const parseFormattedChoices = (text) => {
  try {
    // Extract content between <pre> tags
    const preMatch = text.match(/<pre>(.*?)<\/pre>/s);
    if (!preMatch) return null;

    const preContent = preMatch[1];

    // Split by newlines and extract all non-empty words
    const lines = preContent.split('\n');
    const choices = [];

    lines.forEach(line => {
      // Split line by multiple spaces (column separator)
      const items = line.split(/\s{2,}/).map(item => item.trim()).filter(item => item.length > 0);
      choices.push(...items);
    });

    return choices.length > 0 ? choices : null;
  } catch (error) {
    console.error("Error parsing formatted choices:", error);
    return null;
  }
};

// API base URL - change for production
const API_BASE_URL = "https://demo.iresponse.co.in/cb_api";

// Create axios instance with authentication
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor: Add JWT token to every request
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage (Keycloak token)
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log('🔑 Sending request with auth token');
    } else {
      console.warn('⚠️ No auth token found in localStorage');
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ═══════════════════════════════════════════════════════════
// ✅ DRAG THRESHOLD: Pixels of movement before we consider it a drag
// ═══════════════════════════════════════════════════════════
const DRAG_THRESHOLD = 5;

function Chatbot({
  visible,
  shouldRender,
  messages,
  suggestions,
  showSuggestions,
  loadingSuggestion,
  isLoading,
  chatRef,
  toggleChat,
  toggleSuggestions,
  sendMessage,
  handleSuggestionClick
}) {
  const [input, setInput] = useState('');

    // ✅ ADDED: State for confirmation mode
    // ═══════════════════════════════════════════════════════════
    const [isConfirmationMode, setIsConfirmationMode] = useState(false);
    const [confirmationToolname, setConfirmationToolname] = useState(null);
      const [showAbortConfirmation, setShowAbortConfirmation] = useState(false);
    console.log(confirmationToolname)
      // ✅ NEW: Correction confirmation state
      const [showCorrectionConfirmation, setShowCorrectionConfirmation] = useState(false);
      const [pendingCorrection, setPendingCorrection] = useState(null);
      // Stores: {
      //   slot: "district",
      //   original: "egusarai",
      //   corrected: "Begusarai",
      //   confidence: 85
      // }
    
      // Choice Menu state
      const [showChoiceMenu, setShowChoiceMenu] = useState(false);
      const [pendingChoiceMenu, setPendingChoiceMenu] = useState(null); // Stores {slot: "block", original: "b", choices: [{name: "Bakhtiarpur", confidence: 85}, ...]}
    
      // Progressive Choice Menu state (for 6+ matches with Show More)
      const [showProgressiveMenu, setShowProgressiveMenu] = useState(false);
      const [pendingProgressiveMenu, setPendingProgressiveMenu] = useState(null);
      const [visibleChoicesCount, setVisibleChoicesCount] = useState(5); // Start with 5
    // ADDED: Ref for input auto-focus during multi-turn slot filling
      const inputRef = useRef(null);

      // ADDED: Detect if currently in slot-filling mode (for disabling Quick Actions)
        const [isSlotFillingMode, setIsSlotFillingMode] = useState(false);

    const [downloadedReports, setDownloadedReports] = useState({});
     // Report Menu Visibility State
      // ========================================
      const [showReportMenu, setShowReportMenu] = useState(false);
        const [showInfoMenu, setShowInfoMenu] = useState(false); // <--- ADD THIS LINE
      // Menu Mode State (main menu vs information mode)
        // ========================================
        const [menuMode, setMenuMode] = useState(null); // null = main menu, 'information' = show suggestions
      const [systemTitle, setSystemTitle] = useState("DISASTER MANAGEMENT SYSTEM");
 // ═══════════════════════════════════════════════════════════
  // ✅ NEW: Typewriter effect state
  // ═══════════════════════════════════════════════════════════
  const [typingMessageIndex, setTypingMessageIndex] = useState(null); // Which message is typing
  const [displayedText, setDisplayedText] = useState(''); // Partially revealed text
  const [isTyping, setIsTyping] = useState(false); // Is typing animation active
  const [hasFinishedTyping, setHasFinishedTyping] = useState(false);
  // ✅ NEW: Connection Status State
  const [isOnline, setIsOnline] = useState(true);
// ✅ NEW: Tool Suggestion Popup State
  const [showToolSuggestion, setShowToolSuggestion] = useState(false);
  const [suggestionButtons, setSuggestionButtons] = useState([]);
  console.log(suggestionButtons);

  // ═══════════════════════════════════════════════════════════
  // ✅ DRAGGABLE ICON — State & Refs
  // ═══════════════════════════════════════════════════════════
  const [iconPos, setIconPos] = useState({ right: 20, bottom: 20 });
  const isDraggingRef = useRef(false);
  const hasMovedRef = useRef(false);
  const dragStartRef = useRef({ x: 0, y: 0 });
  const dragStartPosRef = useRef({ right: 20, bottom: 20 });

  // ═══════════════════════════════════════════════════════════
  // ✅ DRAGGABLE ICON — Event Handlers (useCallback for stable refs)
  // ═══════════════════════════════════════════════════════════
 const handleDragMove = useCallback((e) => {
    if (!isDraggingRef.current) return;
    e.preventDefault();

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    const dx = dragStartRef.current.x - clientX;
    const dy = dragStartRef.current.y - clientY;

    if (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD) {
      hasMovedRef.current = true;
    }

    const iconSize = 55;
    const newRight  = Math.max(0, Math.min(window.innerWidth - iconSize, dragStartPosRef.current.right + dx));
    const newBottom = Math.max(0, Math.min(window.innerHeight - iconSize, dragStartPosRef.current.bottom + dy));

    setIconPos({ right: newRight, bottom: newBottom });
  }, []);

  const handleDragEnd = useCallback(() => {
    isDraggingRef.current = false;
    // Remove the class that prevents text selection
    document.body.classList.remove('chatbot-dragging');

    document.removeEventListener('mousemove', handleDragMove);
    document.removeEventListener('mouseup', handleDragEnd);
    document.removeEventListener('touchmove', handleDragMove);
    document.removeEventListener('touchend', handleDragEnd);
  }, [handleDragMove]);

  const handleDragStart = useCallback((e) => {
    // Only left mouse button or touch
    if (e.button && e.button !== 0) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    isDraggingRef.current = true;
    hasMovedRef.current = false;
    dragStartRef.current = { x: clientX, y: clientY };
    dragStartPosRef.current = { ...iconPos };

    // Prevent text selection while dragging
    document.body.classList.add('chatbot-dragging');

    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchmove', handleDragMove, { passive: false });
    document.addEventListener('touchend', handleDragEnd);
  }, [iconPos, handleDragMove, handleDragEnd]);

  // Click handler — only fire toggleChat if user did NOT drag
  const handleToggleClick = useCallback(() => {
    if (!hasMovedRef.current) {
      toggleChat();
    }
  }, [toggleChat]);

  // Cleanup drag listeners on unmount
  useEffect(() => {
    return () => {
      document.removeEventListener('mousemove', handleDragMove);
      document.removeEventListener('mouseup', handleDragEnd);
      document.removeEventListener('touchmove', handleDragMove);
      document.removeEventListener('touchend', handleDragEnd);
      document.body.classList.remove('chatbot-dragging');
    };
  }, [handleDragMove, handleDragEnd]);

  // ═══════════════════════════════════════════════════════════
  // ✅ Compute chat container position based on icon position
  // ═══════════════════════════════════════════════════════════
  const getContainerStyle = () => {
    const containerWidth = 416;
    const containerHeight = 530;
    const gap = 10;
    const iconSize = 55;
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // Icon edges in viewport coordinates (left/top)
    const iconLeft = vw - iconPos.right - iconSize;
    const iconTop  = vh - iconPos.bottom - iconSize;
    const iconRight = iconLeft + iconSize;
    const iconBottom = iconTop + iconSize;

    // Helper: check if a candidate container position overlaps the icon
    const overlaps = (cLeft, cTop) => {
      const cRight  = cLeft + containerWidth;
      const cBottom = cTop + containerHeight;
      return (cLeft < iconRight + gap && cRight > iconLeft - gap &&
              cTop < iconBottom + gap && cBottom > iconTop - gap);
    };

    // Helper: convert left/top to CSS right/bottom
    const toCSS = (left, top) => ({
      right: vw - left - containerWidth,
      bottom: vh - top - containerHeight
    });

    // Helper: check if position fits on screen
    const fitsOnScreen = (left, top) => {
      return left >= 5 && top >= 5 &&
             (left + containerWidth) <= (vw - 5) &&
             (top + containerHeight) <= (vh - 5);
    };

    // ── STRATEGY 1: Container ABOVE the icon ──
    const aboveTop = iconTop - containerHeight - gap;
    const aboveLeft = Math.max(5, Math.min(vw - containerWidth - 5, iconLeft + (iconSize - containerWidth) / 2));
    if (fitsOnScreen(aboveLeft, aboveTop) && !overlaps(aboveLeft, aboveTop)) {
      return toCSS(aboveLeft, aboveTop);
    }

    // Align right edge with icon
    const aboveLeftAligned = Math.max(5, Math.min(vw - containerWidth - 5, vw - iconPos.right - containerWidth));
    if (aboveTop >= 5 && !overlaps(aboveLeftAligned, aboveTop)) {
      return toCSS(aboveLeftAligned, aboveTop);
    }

    // ── STRATEGY 2: Container BELOW the icon ──
    const belowTop = iconBottom + gap;
    const belowLeft = Math.max(5, Math.min(vw - containerWidth - 5, vw - iconPos.right - containerWidth));
    if (fitsOnScreen(belowLeft, belowTop) && !overlaps(belowLeft, belowTop)) {
      return toCSS(belowLeft, belowTop);
    }

    // ── STRATEGY 3: Container to the RIGHT of the icon ──
    const rightLeft = iconRight + gap;
    const rightTop = Math.max(5, Math.min(vh - containerHeight - 5, iconTop));
    if (fitsOnScreen(rightLeft, rightTop) && !overlaps(rightLeft, rightTop)) {
      return toCSS(rightLeft, rightTop);
    }

    // ── STRATEGY 4: Container to the LEFT of the icon ──
    const leftLeft = iconLeft - containerWidth - gap;
    const leftTop = Math.max(5, Math.min(vh - containerHeight - 5, iconTop));
    if (fitsOnScreen(leftLeft, leftTop) && !overlaps(leftLeft, leftTop)) {
      return toCSS(leftLeft, leftTop);
    }

    // ── STRATEGY 5: Opposite corners — container far from icon ──
    const positions = [
      { left: 5, top: 5 },                                                  // top-left
      { left: vw - containerWidth - 5, top: 5 },                            // top-right
      { left: 5, top: vh - containerHeight - 5 },                           // bottom-left
      { left: vw - containerWidth - 5, top: vh - containerHeight - 5 },     // bottom-right
    ];

    // Pick the corner farthest from the icon center
    const iconCX = iconLeft + iconSize / 2;
    const iconCY = iconTop + iconSize / 2;

    positions.sort((a, b) => {
      const distA = Math.hypot((a.left + containerWidth / 2) - iconCX, (a.top + containerHeight / 2) - iconCY);
      const distB = Math.hypot((b.left + containerWidth / 2) - iconCX, (b.top + containerHeight / 2) - iconCY);
      return distB - distA; // farthest first
    });

    for (const pos of positions) {
      if (!overlaps(pos.left, pos.top)) {
        return toCSS(pos.left, pos.top);
      }
    }

    // Absolute fallback
    return toCSS(Math.max(5, vw - containerWidth - 5), 5);
  };

  useEffect(() => {
    const checkStatus = async () => {
      // If we are waiting for a response, we are "connected" & busy.
      // Don't ping health check to avoid false "Offline" timeouts.
      if (isLoading) return;
 
      try {
        // Pings the backend to check connectivity
        await axios.get(`https://demo.iresponse.co.in/cb_api/health`, { timeout: 5000 });
        setIsOnline(true);
      } catch (err) {
        // Only mark offline if we are NOT waiting for a response
        if (!isLoading) setIsOnline(false);
      }
    };
 
    checkStatus(); // Initial check
    const interval = setInterval(checkStatus, 120000); // Re-check every 120 seconds
    return () => clearInterval(interval);
  }, [isLoading]);

 // ✅ NEW: Fetch Region Configuration from Backend
   useEffect(() => {
     const fetchRegionConfig = async () => {
       try {
         const apiUrl = API_BASE_URL;
         const token = localStorage.getItem('auth_token'); // same key as App.jsx interceptor
         const response = await axios.get(`${apiUrl}/region_config`, {
           headers: token ? { Authorization: `Bearer ${token}` } : {}
         });
 
         if (response.data && response.data.header_title) {
           console.log("📍 Region Config Loaded:", response.data.header_title);
           setSystemTitle(response.data.header_title);
         }
       } catch (error) {
         console.error("❌ Error fetching region config:", error);
       }
     };
 
     fetchRegionConfig();
   }, []);
 // Re-fetch region config when chat is first opened — token guaranteed available by then
 useEffect(() => {
   if (!visible) return;
   const fetchRegionConfig = async () => {
     try {
       const apiUrl = API_BASE_URL;
       const token = localStorage.getItem('auth_token');
       const response = await axios.get(`${apiUrl}/region_config`, {
         headers: token ? { Authorization: `Bearer ${token}` } : {}
       });
       if (response.data && response.data.header_title) {
         console.log("📍 Region Config Re-fetched on open:", response.data.header_title);
         setSystemTitle(response.data.header_title);
       }
     } catch (error) {
       console.error("❌ Error re-fetching region config:", error);
     }
   };
   fetchRegionConfig();
 }, [visible]);  // fires every time chat is opened
  // ═══════════════════════════════════════════════════════════
  // ✅ FIX: Clean UI While Generating
  // Force-close all bottom menus/popups when bot is thinking
  // ═══════════════════════════════════════════════════════════
  useEffect(() => {
    if (isLoading) {
      setShowToolSuggestion(false); // Hide "Yes/No" report suggestion
      setShowReportMenu(false);     // Hide Report Menu
      setShowInfoMenu(false);
      setMenuMode(null);            // Hide Quick Actions Grid
      if (showSuggestions) toggleSuggestions(); // Close the panel
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  // ✅ ADDED: Persistent session tied to user login (expires after 8 hours)
    const [sessionId] = useState(() => {
      // Try to restore existing session from browser storage
      const stored = localStorage.getItem('iresponse_chatbot_session');
  
      if (stored) {
        try {
          const { id, expiresAt } = JSON.parse(stored);
  
          // Check if session is still valid (not expired)
          if (Date.now() < expiresAt) {
            console.log('[Chatbot] ✅ Restored existing session:', id);
            return id;
          } else {
            console.log('[Chatbot] ⏰ Session expired, creating new one');
            localStorage.removeItem('iresponse_chatbot_session');
          }
        } catch (e) {
          console.error('[Chatbot] ❌ Error parsing stored session:', e);
          localStorage.removeItem('iresponse_chatbot_session');
        }
      }
  
      // Create new session ID
      const newId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
      // Store it in browser with 8-hour expiration
      localStorage.setItem('iresponse_chatbot_session', JSON.stringify({
        id: newId,
        expiresAt: Date.now() + (8 * 60 * 60 * 1000), // 8 hours in milliseconds
        createdAt: Date.now()
      }));
  
      console.log('[Chatbot] 🆕 Created new session:', newId);
      return newId;
    });

    // ✅ useEffect AFTER sessionId is declared
      useEffect(() => {
        const abandonTaskOnMount = async () => {
          try {
            const response = await apiClient.post(
  `/sessions/${sessionId}/abandon-task`
  // No need for full URL or headers - apiClient handles it!
);
            
            if (response.data.task_abandoned) {
              console.log(`🔄 Page refresh: Task abandoned (${response.data.task_type})`);
            }
          } catch (error) {
            console.error('Error abandoning task on mount:', error);
          }
        };
        
        abandonTaskOnMount();
      }, [sessionId]);

      // ═══════════════════════════════════════════════════════════
      // ✅ EFFECT 1: Decide which bot message should be typed
      // ═══════════════════════════════════════════════════════════
      useEffect(() => {
        if (messages.length === 0) return;
      
        const latestMessage = messages[messages.length - 1];
        const latestIndex = messages.length - 1;
      
        // Only apply to bot messages
        if (latestMessage.sender !== 'bot') return;
      
        // Skip typing effect for clickable popups/dialogs
        const hasClickablePopup =
          latestMessage.debug?.confirmation_buttons ||
          latestMessage.debug?.status === 'choice_menu' ||
          latestMessage.debug?.status === 'correction_confirmation' ||
          showAbortConfirmation ||
          showChoiceMenu ||
          showProgressiveMenu ||
          showCorrectionConfirmation;
      
        if (hasClickablePopup) {
          console.log('⏭️ Skipping typing effect for clickable popup');
          return;
        }
      
        // If we already finished typing this message, do nothing
        if (typingMessageIndex === latestIndex && hasFinishedTyping) {
          return;
        }
      
        // If we are already typing this message, do nothing
        if (typingMessageIndex === latestIndex && isTyping) {
          return;
        }
      
        console.log('⌨️ Preparing typewriter for message:', latestIndex);
      
        setTypingMessageIndex(latestIndex);
        setDisplayedText('');
        setIsTyping(true);
        setHasFinishedTyping(false);
      }, [
        messages,
        showAbortConfirmation,
        showChoiceMenu,
        showProgressiveMenu,
        showCorrectionConfirmation,
        typingMessageIndex,
        isTyping,
        hasFinishedTyping,
      ]);
      // ═══════════════════════════════════════════════════════════
      // ✅ EFFECT 2: Perform typing animation on the selected message
      // ═══════════════════════════════════════════════════════════
      useEffect(() => {
        if (typingMessageIndex === null) return;
        if (!isTyping) return;
      
        const message = messages[typingMessageIndex];
        if (!message || message.sender !== 'bot') return;
      
        // Remove markdown bold markers for typing view only
        const rawText = message.text || '';
        const fullText = rawText
          .replace(/\*\*(.+?)\*\*/g, '$1')
          .replace(/<[^>]*>?/gm, '')     // ✨ Add this: Strips all HTML tags
          .replace(/─{5,}/g, '');
        if (!fullText) {
          setIsTyping(false);
          setHasFinishedTyping(true);
          return;
        }
      
        console.log('⌨️ Starting typewriter effect for message:', typingMessageIndex);
        console.log('📝 Full text length:', fullText.length);
      
        let currentCharIndex = 0;
        const typingSpeed = 0.5; // ms per character
      
        const typingInterval = setInterval(() => {
          currentCharIndex += 1;
      
          if (currentCharIndex <= fullText.length) {
            setDisplayedText(fullText.substring(0, currentCharIndex));
          } else {
            clearInterval(typingInterval);
            setIsTyping(false);
            setHasFinishedTyping(true);
            console.log('✅ Typewriter effect completed');
          }
        }, typingSpeed);
      
        return () => {
          console.log('🧹 Cleaning up typing interval for message:', typingMessageIndex);
          clearInterval(typingInterval);
        };
      }, [typingMessageIndex, isTyping, messages]);
      
      // ═══════════════════════════════════════════════════════════
        // ✅ FIX: AUTO-SCROLL LOGIC
        // This ensures the chat stays at the bottom while typing/loading
        // ═══════════════════════════════════════════════════════════
        useEffect(() => {
          if (chatRef.current) {
            // Instant scroll to bottom to keep up with typewriter speed
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
          messages,           // Scroll when new message arrives
          displayedText,      // Scroll while text is typing (expands height)
          isLoading,          // Scroll when loading skeleton appears
          isTyping,           // Scroll when typing starts/stops
          showChoiceMenu,     // Scroll when menus appear
          showProgressiveMenu,
          showAbortConfirmation,
          showCorrectionConfirmation,
          visible
        ]);
        // 1. Reset to Main Menu whenever the Quick Actions panel closes
        useEffect(() => {
          if (!showSuggestions) {
            setMenuMode(null); // Reset to Main Menu
          }
        }, [showSuggestions]);
      
      // ═══════════════════════════════════════════════════════════
        // ✅ FIX: AUTO-CLOSE MENU ON REPLY
        // This logic ensures the menu closes and resets ONLY when a 
        // NEW message arrives from the bot.
        // ═══════════════════════════════════════════════════════════
        
        // Ref to track message count so we don't close the menu when YOU open it
        const prevMsgCount = useRef(messages.length);
      
        useEffect(() => {
          // Only execute if a NEW message has actually arrived
          if (messages.length > prevMsgCount.current) {
            const lastMessage = messages[messages.length - 1];
            
            // If the new message is from the Bot and the Menu is visible
            if (lastMessage.sender === 'bot' && showSuggestions) {
              toggleSuggestions(); // 1. Close the menu
              setMenuMode(null);   // 2. Reset to Main Interface for next time
            }
          }
          
          // Update the ref for the next cycle
          prevMsgCount.current = messages.length;
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [messages, showSuggestions]);
      
      // ═══════════════════════════════════════════════════════════
        // ✅ NEW: Detect Tool Suggestion (Flag OR Text Match)
        // ═══════════════════════════════════════════════════════════
      useEffect(() => {
          // 1. Basic checks: Must have messages and not be loading network data
          if (messages.length === 0 || isLoading) return;
      
          const latestIndex = messages.length - 1;
          const latestMessage = messages[latestIndex];
      
          // 2. Only apply to bot messages
          if (latestMessage.sender !== 'bot') return;
      
          // 3. 🛡️ ANTI-RACE CONDITION:
          // We must wait until the typing system has "claimed" this message.
          // If typingMessageIndex doesn't match the current message index, 
          // it means the typewriter effect hasn't started yet. We must wait.
          if (typingMessageIndex !== latestIndex) return;
      
          // 4. Wait for the typing animation to completely finish
          if (isTyping || !hasFinishedTyping) return;
      
          // 5. Logic: Backend Flag OR Specific Text Phrase
          const hasBackendFlag = latestMessage.ui_directive?.show_tool_suggestion;
          const hasMatchingText = typeof latestMessage.text === 'string' && 
                                  latestMessage.text.includes("Would you like to proceed with report generation");
      
          if (hasBackendFlag || hasMatchingText) {
            console.log("💡 Tool suggestion detected (Animation Fully Complete) - showing popup");
            setShowToolSuggestion(true);
            setSuggestionButtons(latestMessage.ui_directive?.tool_suggestion_buttons || []);
            
            // Ensure slot filling mode is off so we see the popup actions
            setIsSlotFillingMode(false); 
          }
        }, [messages, isLoading, isTyping, hasFinishedTyping, typingMessageIndex]); // ✅ All dependencies are crucial
      
        // ✅ NEW: Handlers for Suggestion Popup
        const handleToolSuggestionAccept = () => {
          console.log("✅ User accepted tool suggestion");
          sendMessage("Yes", { 
            interaction_type: "manual", 
            session_id: sessionId 
          });
          setShowToolSuggestion(false);
        };
      
        const handleToolSuggestionDismiss = () => {
          console.log("❌ User dismissed tool suggestion");
          sendMessage("No", { 
            interaction_type: "manual", 
            session_id: sessionId 
          });
          setShowToolSuggestion(false);
        };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowToolSuggestion(false);
    // ✅ NEW: Complete any ongoing typing before sending new message
    completeTypingInstantly();
    if (!input.trim()) return;

    const userInput = input.trim().toLowerCase();

    // ============================================
    // ✅ SPECIAL HANDLING: Detect "abort" typed by user
    // ============================================
    if (userInput === "abort") {
      console.log("🛑 User typed 'abort' - showing confirmation dialog");
      console.log("📍 Using session ID:", sessionId);

      // Send "abort" to backend silently
      sendMessage("abort", {
        interaction_type: "manual",
        session_id: sessionId,
      });

      // Show Yes/No dialog immediately
      setShowAbortConfirmation(true);

      // Clear input
      setInput("");

      return; // ⚠️ Don't continue to normal message flow
    }

    // ============================================
    // Normal message flow (for non-abort messages)
    // ============================================
    console.log("PHASE 1 DIAGNOSTIC - Manual input submitted:", input);
    sendMessage(input, {
      interaction_type: "manual",
      session_id: sessionId,
    });
    setInput("");
  };

  const closeChat = () => toggleChat();

  const handleReset = () => {
  // Reset input
  setInput('');
  // ✅ Reset all menu states
  setShowChoiceMenu(false);
  setPendingChoiceMenu(null);
  setShowProgressiveMenu(false);
  setPendingProgressiveMenu(null);
  setVisibleChoicesCount(5);
  // ✅ Reset confirmation dialogs
  setShowAbortConfirmation(false);
  setShowCorrectionConfirmation(false);
  setPendingCorrection(null);
  setIsConfirmationMode(false);
  setConfirmationToolname(null);
  // ✅ Reset slot-filling mode
  setIsSlotFillingMode(false);
  // ✅ Reset menu mode to main menu
  setMenuMode(null);
  // ✅ Reset report menu
  setShowReportMenu(false);
  setShowInfoMenu(false);
  setShowToolSuggestion(false); // ✅ Add this
  setSuggestionButtons([]);     // ✅ Add this
  // Call parent reset (resets messages)
  if (window.resetChat) {
    window.resetChat();
  }
  console.log("🔄 Chat reset: All menus and states cleared");
};

  // ═══════════════════════════════════════════════════════════
  // ✅ NEW: Complete typing instantly when user interrupts
  // ═══════════════════════════════════════════════════════════
  const completeTypingInstantly = () => {
    if (isTyping && typingMessageIndex !== null) {
      const message = messages[typingMessageIndex];
      if (message) {
        setDisplayedText(message.text || '');
        setIsTyping(false);
        console.log('⚡ Typing completed instantly (user interrupted)');
      }
    }
  };

  // ✅ NEW - Sends "abort" to backend first
  const handleAbortClick = () => {
    console.log("🛑 Abort button clicked - sending 'abort' to backend");
    console.log("📍 Using session ID:", sessionId);

    // Send "abort" to backend (backend will ask for confirmation)
    sendMessage("abort", { interaction_type: 'manual', session_id: sessionId });
    // Show Yes/No dialog immediately (don't wait for backend)
    setShowAbortConfirmation(true);
  };

  // ✅ FIXED: Handle abort confirmation - user clicked Yes
  const handleAbortConfirm = async () => {
    console.log("✅ User confirmed abort - sending 'yes' to backend");
    console.log("📍 Using session ID:", sessionId);

    try {
      sendMessage("yes", {
        interaction_type: "manual",
        session_id: sessionId,
      });

      setShowAbortConfirmation(false);
      console.log("✅ Abort confirmation sent");
    } catch (error) {
      console.error("❌ ERROR sending abort confirmation:", error);
      setShowAbortConfirmation(false);
      alert("Error confirming abort. Please try again.");
    }
  };


  // ✅ FIXED: Handle abort cancellation - user clicked No
  const handleAbortCancel = () => {
    console.log("❌ User cancelled abort - sending 'no' to backend");
    console.log("📍 Using session ID:", sessionId);

    try {
      sendMessage("no", {
        interaction_type: "manual",
        session_id: sessionId,
      });

      setShowAbortConfirmation(false);
      console.log("✅ Abort cancellation sent");
    } catch (error) {
      console.error("❌ ERROR sending abort cancellation:", error);
      setShowAbortConfirmation(false);
    }
  };

  // ============================================
  // Correction Confirmation Handlers
  // ============================================

  const handleCorrectionAccept = () => {
    console.log("✅ User accepted correction - sending 'yes' to backend");
    console.log("📍 Correction:", pendingCorrection);
    console.log("📍 Using session ID:", sessionId);

    try {
      sendMessage("yes", {
        interaction_type: "manual",
        session_id: sessionId,
      });

      setShowCorrectionConfirmation(false);
      setPendingCorrection(null);
      console.log("✅ Correction acceptance sent");
    } catch (error) {
      console.error("❌ ERROR sending correction acceptance:", error);
      setShowCorrectionConfirmation(false);
      setPendingCorrection(null);
      alert("Error accepting correction. Please try again.");
    }
  };

  const handleCorrectionReject = () => {
    console.log("❌ User rejected correction - sending 'no' to backend");
    console.log("📍 Correction:", pendingCorrection);
    console.log("📍 Using session ID:", sessionId);

    try {
      sendMessage("no", {
        interaction_type: "manual",
        session_id: sessionId,
      });

      setShowCorrectionConfirmation(false);
      setPendingCorrection(null);
      console.log("✅ Correction rejection sent");
    } catch (error) {
      console.error("❌ ERROR sending correction rejection:", error);
      setShowCorrectionConfirmation(false);
      setPendingCorrection(null);
    }
  };

  // ============================================
  // Choice Menu Handlers
  // ============================================
  const handleChoiceClick = (choiceName) => {
    console.log("✅ User selected choice:", choiceName);
    console.log("Using session ID:", sessionId);

    try {
      sendMessage(choiceName, { interaction_type: 'manual', session_id: sessionId });

      // Reset both menu types
      setShowChoiceMenu(false);
      setPendingChoiceMenu(null);
      setShowProgressiveMenu(false);
      setPendingProgressiveMenu(null);
      setVisibleChoicesCount(5);

      console.log("✅ Choice selection sent");
    } catch (error) {
      console.error("❌ ERROR sending choice selection:", error);
      setShowChoiceMenu(false);
      setPendingChoiceMenu(null);
      setShowProgressiveMenu(false);
      setPendingProgressiveMenu(null);
      alert("Error sending choice selection. Please try again.");
    }
  };

  const handleNoneOfThese = () => {
    console.log("🚫 User clicked 'None of These'");
    console.log("Using session ID:", sessionId);

    try {
      sendMessage("none", { interaction_type: "manual", session_id: sessionId });

      // Reset both menu types
      setShowChoiceMenu(false);
      setPendingChoiceMenu(null);
      setShowProgressiveMenu(false);
      setPendingProgressiveMenu(null);
      setVisibleChoicesCount(5);

      console.log("✅ 'None of These' sent");
    } catch (error) {
      console.error("❌ ERROR sending 'none of these':", error);
      setShowChoiceMenu(false);
      setPendingChoiceMenu(null);
      setShowProgressiveMenu(false);
      setPendingProgressiveMenu(null);
    }
  };

  // Progressive Menu Handler - Show More
  const handleShowMore = () => {
    console.log("📖 Show More clicked");
    console.log(`Current visible: ${visibleChoicesCount}, Total: ${pendingProgressiveMenu?.totalCount}`);

    // Show next 10 choices
    const newCount = Math.min(
      visibleChoicesCount + 10,
      pendingProgressiveMenu?.totalCount || 0
    );

    setVisibleChoicesCount(newCount);
    console.log(`Updated visible count to: ${newCount}`);
  };

  // ═══════════════════════════════════════════════════════════
    // ✅ ADDED: Handle confirmation button clicks
    // ═══════════════════════════════════════════════════════════
    const handleConfirmationAction = (action) => {
      // Send action as text to maintain backend compatibility
      sendMessage(action, { interactiontype: "manual", session_id: sessionId });
  
      // Exit confirmation mode
      setIsConfirmationMode(false);
      setConfirmationToolname(null);
    };
    // ═══════════════════════════════════════════════════════════
  
    // ═══════════════════════════════════════════════════════════
    // ✅ ADDED: Watch for confirmation state in latest message
    // ═══════════════════════════════════════════════════════════
    useEffect(() => {
      if (messages.length > 0) {
        const latestMessage = messages[messages.length - 1];
  
        // Check if latest bot message has confirmation buttons
        if (
          latestMessage.sender === "bot" &&
          latestMessage.debug?.confirmation_buttons
        ) {
          setIsConfirmationMode(true);
          setConfirmationToolname(latestMessage.debug?.toolname || null);
        }
      }
    }, [messages]);

      // ═══════════════════════════════════════════════════════════
      // ✅ ADDED: Watch for confirmation state in latest message
      // ═══════════════════════════════════════════════════════════
      useEffect(() => {
        if (messages.length > 0) {
          const latestMessage = messages[messages.length - 1];
    
          // Check if latest bot message has confirmation buttons
          if (
            latestMessage.sender === "bot" &&
            latestMessage.debug?.confirmation_buttons
          ) {
            setIsConfirmationMode(true);
            setConfirmationToolname(latestMessage.debug?.toolname || null);
          }
        }
      }, [messages]);

      // ============================================
        // Detect correction confirmation from backend
        // ============================================
        useEffect(() => {
          if (messages.length > 0) {
            const latestMessage = messages[messages.length - 1];
      
            // Check if backend sent correction_confirmation status
            if (
              latestMessage.sender === "bot" &&
              latestMessage.debug?.status === "correction_confirmation"
            ) {
              console.log("🔔 Backend requested correction confirmation");
              console.log("📍 Correction data:", latestMessage.debug?.correction);
      
              setShowCorrectionConfirmation(true);
              setPendingCorrection(latestMessage.debug?.correction || null);
              setIsSlotFillingMode(true); // Keep slot filling mode active
            }
          }
        }, [messages]);
      
        // ============================================
        // 🔄 Detect choice menu from backend
        // ============================================
        // Detect choice menu from backend (2-5 matches OR 6+ matches)
        useEffect(() => {
          if (messages.length > 0) {
            const latestMessage = messages[messages.length - 1];
      
            // CASE 1: Backend sent explicit choice menu (2-5 matches)
            if (latestMessage.sender === 'bot' && latestMessage.debug?.status === 'choice_menu') {
              console.log("✅ Backend sent choice menu (2-5 matches)");
              console.log("Choice menu data:", latestMessage.debug?.choice_menu);
              setShowChoiceMenu(true);
              setPendingChoiceMenu(latestMessage.debug?.choice_menu || null);
              setIsSlotFillingMode(true);
      
              // Reset progressive menu
              setShowProgressiveMenu(false);
              setPendingProgressiveMenu(null);
              setVisibleChoicesCount(5);
            }
            // CASE 2: Detect 6+ matches OR no match (all available) from formatted text (progressive menu)
            else if (latestMessage.sender === 'bot' && latestMessage.text) {
              // Check if message contains formatted list with <pre> block
              const hasMultipleMatches = latestMessage.text.includes('I found multiple') && latestMessage.text.includes('<pre>');
      
              // Detect "All available" OR "not found" patterns (both show full list)
              const hasNoMatch = (
                (latestMessage.text.includes('All available') || latestMessage.text.includes('not found')) &&
                latestMessage.text.includes('<pre>')
              );
      
              if (hasMultipleMatches || hasNoMatch) {
                console.log("✅ Detected formatted list - activating progressive menu");
                console.log(`Type: ${hasMultipleMatches ? 'Multiple matches' : 'No match (all available)'}`);
      
                // Parse the formatted choices
                const allChoices = parseFormattedChoices(latestMessage.text);
      
                const shouldShowMenu =
  (hasMultipleMatches && allChoices && allChoices.length > 5) ||  // 6+ fuzzy matches
  (hasNoMatch && allChoices && allChoices.length > 0);             // Any count for validation errors
 
if (shouldShowMenu) {
            // Extract the original user input and field name from the message
            let original = '';
            let fieldName = 'option';

            if (hasMultipleMatches) {
              // Pattern: "I found multiple blocks starting with 'b'"
              const originalMatch = latestMessage.text.match(/starting with '(.+?)'/);
              original = originalMatch ? originalMatch[1] : '';

              const fieldMatch = latestMessage.text.match(/I found multiple (.+?)s starting/);
              fieldName = fieldMatch ? fieldMatch[1] : 'option';
            } else {
              // Pattern 1: "No block starts with 'e'"
              // Pattern 2: "'asdgasda' not found"
              // Pattern 3: "All available blocks"

              let originalMatch = latestMessage.text.match(/starts with '(.+?)'/);
              if (!originalMatch) {
                originalMatch = latestMessage.text.match(/'(.+?)' not found/);
              }
              original = originalMatch ? originalMatch[1] : 'your input';

                    //  Extract field name correctly
                    let fieldMatch = latestMessage.text.match(/No (.+?) starts with/);
                    if (!fieldMatch) {
                      // Match word characters before 's (', not any chars before 's'
                      fieldMatch = latestMessage.text.match(/All available (\w+(?:\s+\w+)?)\s*\(/);
                    }
                    if (!fieldMatch) {
                      // Remove emoji and extract field name from "X: 'input' not found"
                      fieldMatch = latestMessage.text.match(/❌\s*(\w+(?:_\w+)?):.*not found/);
                    }
                    fieldName = fieldMatch ? fieldMatch[1].trim().replace("_", " ") : "option";
            }

            console.log(`Found ${allChoices.length} choices for "${original}"`);
      
                  // Set progressive menu state
                  setShowProgressiveMenu(true);
                  setPendingProgressiveMenu({
                    original: original,
                    fieldName: fieldName,
                    allChoices: allChoices,
                    totalCount: allChoices.length
                  });
                  setVisibleChoicesCount(5); // Start with 5
                  setIsSlotFillingMode(true);
      
                  // Reset regular choice menu
                  setShowChoiceMenu(false);
                  setPendingChoiceMenu(null);
                }
              }
              /* --- 👇 INSERT NEW CODE BELOW THIS LINE 👇 --- */
        else {
            // Check if the bot is actively collecting a parameter (Slot Filling Mode)
            const tier = latestMessage.tier || latestMessage.debug?.tier || latestMessage.debug_info?.tier || '';
            const isPrompt = tier.includes('COLLECTING_PARAMS') || tier.includes('PROMPT') || tier.includes('SLOT_FILLING');
 
            // Ignore if it's the final confirmation screen
            if (isPrompt && !latestMessage.text.includes('Review Your Input')) {
                const lines = latestMessage.text.split('\n');
                const choices = [];
                // Regex to match list items like "1️⃣ Infrastructure", "1. Flood", or "• Leh"
                const listRegex = /^([0-9]️⃣|🔟|\d+\.|•|-)\s+(.+)$/;
 
                lines.forEach(line => {
                    // Strip bold markdown so buttons look clean
                    let cleanLine = line.trim().replace(/\*\*/g, '');
                    const match = cleanLine.match(listRegex);
                    // Exclude validation rows like "1. District: Patna"
                    if (match && !cleanLine.includes(':')) {
                        choices.push({ name: match[2].trim(), confidence: 100 });
                    }
                });
 
                // If we found a list, hijack the UI and show the buttons!
                if (choices.length > 0) {
                    console.log("✅ Detected list in prompt - converting to clickable choice menu");
                    // Use the first line of the message as the menu title
                    const questionText = latestMessage.text.split(/\n/)[0].replace(/\*\*/g, '').trim() || "Please select an option:";
 
                    setShowChoiceMenu(true);
                    setPendingChoiceMenu({
                        original: questionText,
                        choices: choices
                    });
                    setIsSlotFillingMode(true);
                    setShowProgressiveMenu(false);
                }
            }
        }
        /* --- 👆 INSERT NEW CODE ABOVE THIS LINE 👆 --- */
            }
          }
        }, [messages]);
    
      // Auto-focus input during multi-turn slot filling + validation errors
      // ═══════════════════════════════════════════════════════════
        // ✅ FIX 1: Logic to determine Slot Filling Mode (Keep this for Abort Button)
        // ═══════════════════════════════════════════════════════════
        useEffect(() => {
          if (messages.length > 0) {
            const latestMessage = messages[messages.length - 1];
            
            // ✅ CRITICAL FIX: Check ALL possible locations where tier might be stored
            const tier = latestMessage.tier ||                    // Root level
                         latestMessage.debug?.tier ||             // debug.tier
                         latestMessage.debug_info?.tier ||        // debug_info.tier
                         '';
      
            // ✅ SURGICAL FIX: Be specific - only match ACTUAL slot filling states
            const isSlotFillingPrompt =
              tier.includes('COLLECTING_PARAMS') ||
              tier.includes('PROMPT') ||
              tier.includes('SLOT_FILLING') ||  // ✅ Specific to slot filling
              tier.includes('VALIDATION_ERROR') ||
              // ✅ Fallback: Check if message text contains slot-filling indicators
              (latestMessage.text && (
                latestMessage.text.includes('Which district?') ||
                latestMessage.text.includes(' Example:') ||
                latestMessage.text.includes('Which block?') ||
                latestMessage.text.includes('From date?') ||
                latestMessage.text.includes('To date?') ||
                latestMessage.text.includes('Start date?') ||
                latestMessage.text.includes('End date?')
              ) && !latestMessage.text.includes('Download the full report'));  // ✅ Exclude final result
      
            // ✅ FIXED: More accurate task completion detection
            const isTaskFinished =
              tier.includes('CANCELLED') ||
              tier.includes('COMPLETED') ||
              tier.includes('TERMINATED') ||
              tier.includes('TOOL_RESULT') ||  // ✅ NEW: When tool execution finishes
              (latestMessage.debug?.excel_enabled !== undefined ||
               latestMessage.debug?.pdf_enabled !== undefined) ||
              (latestMessage.text && (
                latestMessage.text.includes('Report generation cancelled') ||
                latestMessage.text.includes('Operation cancelled') ||
                latestMessage.text.includes('Report generated successfully') ||
                latestMessage.text.includes('Download the full report') ||  // ✅ NEW: Final result indicator
                latestMessage.text.includes('Task cancelled successfully')
              ));
      
            // Only turn ON slot filling mode (Abort button) if task is NOT finished
            if (latestMessage.sender === 'bot' && isSlotFillingPrompt && !isConfirmationMode && !isTaskFinished) {
              setIsSlotFillingMode(true);
            } else {
              setIsSlotFillingMode(false);
            }
          }
        }, [messages, isConfirmationMode]);
     
       // ═══════════════════════════════════════════════════════════
       // ✅ FIX 2: UNIVERSAL AUTO-FOCUS (Runs whenever bot stops working)
       // ═══════════════════════════════════════════════════════════
       useEffect(() => {
         // Check if the UI is "Interactive" (Not loading, not typing, no popup dialogs)
         const isInteractive = 
           !isLoading && 
           !isTyping && 
           !showAbortConfirmation && 
           !showChoiceMenu && 
           !showProgressiveMenu && 
           !showCorrectionConfirmation;
     
         // If interactive and input exists, focus it!
         if (isInteractive && inputRef.current) {
           // Small timeout ensures the 'disabled' attribute is fully removed from DOM
           setTimeout(() => {
             inputRef.current?.focus();
           }, 50);
         }
       }, [
         // Re-run whenever any of these blocking states change
         isLoading, 
         isTyping, 
         showAbortConfirmation, 
         showChoiceMenu, 
         showProgressiveMenu, 
         showCorrectionConfirmation,
         messages // Also run when a new message fully arrives
       ]);


    // ═══════════════════════════════════════════════════════════
  
     // ========================================
      // Watch for suggestion changes (optional optimization)
      // ========================================
      useEffect(() => {
        // When backend sends new suggestions during navigation (e.g., Dashboard -> Flood Dashboard),
        // keep the user in 'information' mode to show those suggestions
        // This ensures smooth navigation without resetting to main menu
    
        // No action needed - just a placeholder for future enhancements
        // The menuMode state already handles this correctly
      }, [suggestions, menuMode]);

    const renderSuggestions = () => {
        // Hide if processing or if the menu is closed
        if (isLoading || isTyping || isSlotFillingMode || !showSuggestions) return null;
    
        // ========================================
        // PHASE 1: Main Menu (Only Grid)
        // ========================================
        if (menuMode === null) {
          return (
            <div className="suggestions-container">
              <div className="suggestions-grid">
                <button
                  className="suggestion-button main-menu-btn information"
                  onClick={() => setShowInfoMenu(true)}
                >
                  <span className="suggestion-icon">💬</span>
                  <span>Information</span>
                </button>
                <button
                  className="suggestion-button main-menu-btn report-generation"
                  onClick={() => setShowReportMenu(true)}
                >
                  <span className="suggestion-icon">📊</span>
                  <span>Reports</span>
                </button>
              </div>
            </div>
          );
        }
    
       
    
        return null;
      };
    // ✅ UPGRADE: "Cyber-Drone" 3D Robot Head
      const renderBotAvatar = () => (
        <div className="bot-head-3d">
          {/* The 6 Sides of the Cube Head */}
          <div className="head-face front">
            <div className="bot-screen">
              <div className="bot-eye"></div>
              <div className="bot-eye"></div>
            </div>
          </div>
          <div className="head-face back"></div>
          <div className="head-face right"></div>
          <div className="head-face left"></div>
          <div className="head-face top"></div>
          <div className="head-face bottom"></div>
          
          {/* Mechanical Details */}
          <div className="bot-ear left"></div>
          <div className="bot-ear right"></div>
        </div>
      );
    
    // ✅ UPGRADE: Professional AI HUD Component
          const AiThinkingIndicator = () => {
            const [step, setStep] = useState(0);
            
            // Technical, "Under-the-hood" steps
            const steps = [
              "Authenticating request...",
              "Querying disaster_db...",
              "Aggregating block data...",
              "Formatting output...",
              "Finalizing response..."
            ];
    
            useEffect(() => {
              // Progress faster through steps
              const interval = setInterval(() => {
                setStep((prev) => (prev + 1) % steps.length);
              }, 800); 
              return () => clearInterval(interval);
              // eslint-disable-next-line react-hooks/exhaustive-deps
            }, []);
    
            return (
              <div className="ai-hud-container">
                <div className="hud-status-dot"></div>
                <span style={{ letterSpacing: '0.5px', textTransform: 'uppercase', fontWeight: 600 }}>
                  AI_CORE:
                </span>
                <span>{steps[step]}</span>
              </div>
            );
          };

  // ═══════════════════════════════════════════════════════════
  // ✅ Compute dynamic container style
  // ═══════════════════════════════════════════════════════════
  const containerStyle = getContainerStyle();

  return (
    <>
      {/* ✅ DRAGGABLE TOGGLE BUTTON */}
      <button
        className="chat-toggle"
        style={{
          right: `${iconPos.right}px`,
          bottom: `${iconPos.bottom}px`,
        }}
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
        onClick={handleToggleClick}
      >
        <Bot style={{color: "#f7f7f7"}} size={26} />
        {/* Only show tooltip if the chat window is NOT visible */}
{!visible && <span className={`toggle-tooltip${(window.innerWidth - iconPos.right - 56) < 220 ? ' tooltip-right' : ''}`}>Ask iResponse Assistant</span>}
      </button>
      {shouldRender && (
        <div
          className={`chatbot-container ${visible ? 'visible' : ''}`}
          style={{
            right: `${containerStyle.right}px`,
            bottom: `${containerStyle.bottom}px`,
            width: !isOnline ? "407px" : "403px",
          }}
        >
            <div className="chat-header">
            <div className="header-info">
              <h3>
                {/* ✅ DYNAMIC: Toggles 'online' or 'offline' class */}
                <span className={`header-status-pulse ${isOnline ? 'online' : 'offline'}`}></span>
                iResponse AI
              </h3>
              <span style={{ opacity: 0.8, fontSize: '11px', letterSpacing: '0.5px' }}>
                {/* ✅ DYNAMIC: Toggles text */}
                {isOnline ? 'ONLINE' : 'OFFLINE'} • {systemTitle}
              </span>
            </div>
            <div className="header-buttons">
              <button onClick={handleReset} className="reset-button" style={{textDecoration:"none"}} title='Reset'><RotateCcw size={13} /></button>
              <button onClick={closeChat} className="close-button" title='Close'>✕</button>
            </div>
          </div>

          <div
            className={`chat-messages ${showAbortConfirmation ? 'abort-confirmation-active' : ''}`}
            ref={chatRef}
              >

            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>

            {/* 🤖 BOT AVATAR – LEFT SIDE */}
            {msg.sender === 'bot' && (
              <div 
                className={`avatar bot ${
                  (isTyping && index === typingMessageIndex) ? 'speaking' : 'idle'
                }`}
              >
                {renderBotAvatar()}
              </div>
            )}

            {/* MESSAGE BUBBLE */}
            <div className="message-content">
              {index === typingMessageIndex && isTyping ? (
                <div>
                  {displayedText}
                  <span className="typing-cursor">|</span>
                </div>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: formatResponseText(msg.text) }} />
              )}

                  {/* {msg.debug && SHOW_DEBUG_INFO && (
                    <button className="info-button" type="button">
                      ℹ️
                      <div className="info-tooltip">
                        {`Tier: ${msg.debug.tier}\nConf: ${(msg.debug.confidence * 100).toFixed(1)}%\nTime: ${(msg.debug.response_time * 1000).toFixed(0)}ms`}
                      </div>
                    </button>
                  )} */}

       {/* ✅ MODIFIED: Show download buttons only after typing completes */}
            {msg.debug?.tier?.includes('TOOL_AGENT') && 
            !msg.debug?.tier?.includes('PROMPT') && 
            msg.debug?.tool_result?.result?.data && 
            ((msg.debug?.excel_enabled !== false || msg.debug?.pdf_enabled !== false) && 
            !(index === typingMessageIndex && isTyping) && (
              <div className="download-actions">
                       {msg.debug?.excel_enabled !== false && (
                          <button
                            className="download-btn"
                            onClick={() => {
                              const downloadKey = `${index}-excel`;
                              setDownloadedReports(prev => ({ ...prev, [downloadKey]: true }));
                              downloadReport(msg, 'excel', index);
                            }}
                            title="Download as Excel"
                            disabled={downloadedReports[`${index}-excel`]}
                          >
                            📊 Excel
                          </button>
                        )}
                        {msg.debug?.pdf_enabled !== false && (
                          <button
                            className="download-btn"
                            onClick={() => {
                              const downloadKey = `${index}-pdf`;
                              setDownloadedReports(prev => ({ ...prev, [downloadKey]: true }));
                              downloadReport(msg, 'pdf', index);
                            }}
                            title="Download as PDF"
                            disabled={downloadedReports[`${index}-pdf`]}
                          >
                            📄 PDF
                          </button>
                        )}
                    </div>
                  ))}
                </div>
            {/* 🧑 USER AVATAR – RIGHT SIDE */}
            {msg.sender === 'user' && (
              <div className="avatar user">
                <svg className="user-icon-svg" viewBox="0 0 24 24">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M20 21a8 8 0 0 0-16 0" stroke="currentColor" strokeWidth="2" fill="none" />
                </svg>
              </div>
            )}
              </div>
            ))}

            {isLoading && (
                          <div className="message bot">
                            {/* 🧠 AI BRAIN ACTIVE STATE */}
                            <div className="avatar bot thinking">
                              {renderBotAvatar()}
                            </div>
                            
                            {/* UPGRADE: Skeleton Loader + HUD */}
                            <div className="message-content" style={{ minWidth: '200px' }}>
                              
                              {/* The Technical HUD */}
                              <AiThinkingIndicator />
                              
                              {/* The "Ghost" Text Lines */}
                              <div style={{ marginTop: '15px' }}>
                                <div className="skeleton-line medium"></div>
                                <div className="skeleton-line short"></div>
                              </div>
                            </div>
                          </div>
                        )}
          </div>

          {renderSuggestions()}

            {/* ========================================
                Report Menu Component
                ======================================== */}
              <ReportMenu
                sessionId={sessionId}
                visible={showReportMenu}
                onLeafClick={(toolName, label) => {
                  // Close menu
                  setShowReportMenu(false);

                  // Collapse Quick Actions menu
                  setMenuMode(null);

                  // ✅ FIX: Also collapse the suggestions panel if it's currently expanded
                  if (showSuggestions) {
                    toggleSuggestions();
                  }

                  // Send message with special interaction type
                  sendMessage(`Generating ${label}...`, {
                    interaction_type: 'report_menu_leaf',
                    tool_name: toolName,
                    session_id: sessionId
                  });
                }}
                onClose={() => setShowReportMenu(false)}
              />
               {/* ========================================
                              Information Menu Component
                              ======================================== */}
                            <InformationMenu
                              sessionId={sessionId}
                              visible={showInfoMenu}
                              onLeafClick={(section, label) => {
                                setShowInfoMenu(false);
                                setMenuMode(null);
                                if (showSuggestions) toggleSuggestions();
              
                                sendMessage(label, {
                                  interaction_type: 'quick_action',
                                  session_id: sessionId,
                                  quick_action_data: {
                                    section: section,
                                    action: 'trigger_nlp'
                                  }
                                });
                              }}
                              onClose={() => setShowInfoMenu(false)}
                            />

            {/* ═══════════════════════════════════════════════════════════ */}
            {/* ============================================ */}
            {/* MODIFIED: Five modes - Abort, Choice Menu, Correction, Confirmation Buttons, or Input */}
            {/* ============================================ */}
            {showAbortConfirmation ? (
              /* Abort Confirmation Dialog */
              <div className="abort-confirmation-dialog">
                <div className="abort-confirmation-message">
                  <span className="warning-icon">⚠️</span>
                  <p>Are you sure you want to abort this task?</p>
                </div>
                <div className="abort-confirmation-buttons">
                  <button
                    className="abort-confirm-yes-btn"
                    onClick={handleAbortConfirm}
                    disabled={isLoading}
                  >
                    Yes
                  </button>
                  <button
                    className="abort-confirm-no-btn"
                    onClick={handleAbortCancel}
                    disabled={isLoading}
                  >
                    No
                  </button>
                </div>
              </div>
            ) : showProgressiveMenu ? (
              // 🆕 PROGRESSIVE Choice Menu Dialog (6+ matches with Show More)
              <div className="choice-menu-dialog">
                <div className="choice-menu-header">
                  <span className="choice-icon">🔍</span>
                  <h4>Did you mean?</h4>
                </div>

                <div className="choice-menu-message">
                  <p>You typed: <strong>{pendingProgressiveMenu?.original}</strong></p>
                  <p>
                    Found <strong>{pendingProgressiveMenu?.totalCount}</strong>{' '}
                    <span style={{ whiteSpace: 'nowrap' }}>
                      {(() => {
                        const field = pendingProgressiveMenu?.fieldName?.toLowerCase() || "option";
                        const pluralMap = {
                          "district": "districts",
                          "block": "blocks",
                          "disaster type": "disaster types",
                          "disaster_type": "disaster types",
                          "disastertype": "disaster types",
                          "districts": "districts",
                          "blocks": "blocks",
                          "disaster types": "disaster types"
                        };
                        return pluralMap[field] || `${field}s`;
                      })()}
                    </span>
                    . Please select:
                  </p>
                </div>

                <div className="choice-menu-buttons">
                  {pendingProgressiveMenu?.allChoices?.slice(0, visibleChoicesCount).map((choice, index) => (
                    <button
                      key={index}
                      className="choice-menu-option-btn"
                      onClick={() => handleChoiceClick(choice)}
                      disabled={isLoading}
                    >
                      {choice}
                    </button>
                  ))}

                  {/* Show More Button - only if there are more choices */}
                  {visibleChoicesCount < pendingProgressiveMenu?.totalCount && (
                    <button
                      className="choice-menu-show-more-btn"
                      onClick={handleShowMore}
                      disabled={isLoading}
                    >
                      📖 Show More ({pendingProgressiveMenu?.totalCount - visibleChoicesCount} remaining)
                    </button>
                  )}

                  {/* None of These button */}
                  <button
                    className="choice-menu-none-btn"
                    onClick={handleNoneOfThese}
                    disabled={isLoading}
                  >
                    None of These
                  </button>
                </div>
              </div>
            ) : showChoiceMenu ? (
              /* Choice Menu Dialog - NEW! */
              <div className="choice-menu-dialog">
                <div className="choice-menu-header">
                  <span className="choice-icon">🔍</span>
                  <h4>Did you mean?</h4>
                </div>

                <div className="choice-menu-message">
                  <p>You typed: <strong>{pendingChoiceMenu?.original}</strong></p>
                  <p>Please select the correct option:</p>
                </div>

                <div className="choice-menu-buttons">
                  {pendingChoiceMenu?.choices?.map((choice, index) => {
                    // Handle both array and object formats
                    const choiceName = Array.isArray(choice) ? choice[0] : choice.name;
                    const choiceConfidence = Array.isArray(choice) ? choice[1] : choice.confidence;
                    console.log(choiceConfidence);

                    return (
                      <button
                        key={index}
                        className="choice-menu-option-btn"
                        onClick={() => handleChoiceClick(choiceName)}
                        disabled={isLoading}
                      >
                        <span className="choice-name">{choiceName}</span>
                        {/*<span className="choice-confidence">{choiceConfidence}%</span>*/}
                      </button>
                    );
                  })}

                  {/* None of These button */}
                  <button
                    className="choice-menu-none-btn"
                    onClick={handleNoneOfThese}
                    disabled={isLoading}
                  >
                    ❌ None of These
                  </button>
                </div>
              </div>
            ) : showCorrectionConfirmation ? (
              /* Correction Confirmation Dialog */
              <div className="correction-confirmation-dialog">
                <div className="correction-confirmation-header">
                  <span className="correction-icon">💡</span>
                  <h4>Did you mean this?</h4>
                </div>

                <div className="correction-details">
                  <div className="correction-row">
                    <span className="correction-label">Original:</span>
                    <span className="correction-original">{pendingCorrection?.original}</span>
                  </div>
                  <div className="correction-row">
                    <span className="correction-label">Suggested:</span>
                    <span className="correction-suggested">{pendingCorrection?.corrected}</span>
                  </div>
                </div>

                <div className="correction-confirmation-buttons">
                  <button
                    className="correction-accept-btn"
                    onClick={handleCorrectionAccept}
                    disabled={isLoading}
                  >
                    ✓ Yes
                  </button>
                  <button
                    className="correction-reject-btn"
                    onClick={handleCorrectionReject}
                    disabled={isLoading}
                  >
                    ✗ No
                  </button>
                </div>
              </div>
) : showToolSuggestion ? (
            /* ✅ NEW: Tool Suggestion Popup */
            <div className="tool-suggestion-dialog">
              <div className="tool-suggestion-header">
                <span className="suggestion-icon">💡</span>
                <h4>Report Suggestion</h4>
              </div>
              
              <div className="tool-suggestion-message">
                <p><strong>Would you like to proceed with report generation?</strong></p>
              </div>

              <div className="tool-suggestion-buttons">
                <button
                  className="suggestion-accept-btn"
                  onClick={handleToolSuggestionAccept}
                  disabled={isLoading}
                >
                  Yes
                </button>
                <button
                  className="suggestion-dismiss-btn"
                  onClick={handleToolSuggestionDismiss}
                  disabled={isLoading}
                >
                  No
                </button>
              </div>
            </div>
          ) : isConfirmationMode ? (
            /* Existing Confirmation Buttons (Confirm/Restart/Cancel) */
            <div className="confirmation-buttons">
              <button
                className="confirm-btn"
                onClick={() => handleConfirmationAction("confirm")}
                disabled={isLoading}
              >
                Confirm
              </button>
              <button
                className="restart-btn"
                onClick={() => handleConfirmationAction("restart")}
                disabled={isLoading}
              >
                Restart
              </button>
              <button
                className="cancel-btn"
                onClick={() => handleConfirmationAction("cancel")}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          ) : (
<div className="input-container-with-abort">
              
              {/* LEFT SIDE: Logic to switch between ABORT or MENU button */}
              {isSlotFillingMode ? (
                // 🛑 Abort Button (Only appears during active tasks/report generation)
                <button
                  className="abort-btn-left"
                  onClick={handleAbortClick}
                  disabled={isLoading}
                  title="Abort task"
                >
                  <span className="abort-icon">⛔</span>
                </button>
              ) : (
                // ⚡ UPDATED: High-Tech Chip Button
                <button
                  className={`action-toggle-btn ${showSuggestions ? 'active' : ''}`}
                  onClick={toggleSuggestions}
                  title="Access Quick Actions"
                  disabled={isLoading || isTyping}
                >
                  <span style={{ fontSize: '14px' }}>⚡</span>
                  <span>QUICK ACTIONS</span>
                </button>
              )}

              {/* CENTER: The Search Input */}
              <form onSubmit={handleSubmit} className="chat-input-form">
                <input
                  ref={inputRef}
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  title="Ask about disaster management..."
                  placeholder={
                    showAbortConfirmation
                      ? "Please click Yes or No above..."
                      : isSlotFillingMode
                      ? "Type your answer..."
                      : "Ask about disaster management..."
                  }
                  className="chat-input"
                  disabled={isLoading || isTyping || showAbortConfirmation || showChoiceMenu || showCorrectionConfirmation}
                />
                
                {/* RIGHT: Send Button */}
                <button
                  type="submit"
                  className="send-button"
                  title="Send"
                  disabled={isLoading || isTyping || showAbortConfirmation || !input.trim()}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </form>
            </div>
            )}

            {/* ═══════════════════════════════════════════════════════════ */}


        </div>
      )}
    </>
  );
}

export default Chatbot;